import { faCode, faDatabase } from "@fortawesome/free-solid-svg-icons";

export const excludedDirs = [
  "node_modules", "__pycache__", ".git", "dist", "out-tsc", ".angular", ".vscode"
];

export const targetTechOptions = 
{
  "Python": {
    "options": [
      "Java", "Spring Boot", "Node.js", "Go", "Django", "Flask", "FastAPI", "Ruby on Rails", 
      "ASP.NET", "Kotlin", "Scala", "Elixir", "Rust", "PHP", "Perl", "R"
    ],
    "fileTypes": {
      "Java": [".java", ".class", ".jar", "pom.xml", "build.gradle", ".jmod"],
      "Spring Boot": [".java", ".class", ".jar", "pom.xml", "application.properties", "application.yml", ".env"],
      "Node.js": [".js", ".json", "package.json", ".ts", ".env", ".mjs", "tsconfig.json"],
      "Go": [".go", "go.mod", "go.sum", "go.work", ".env"],
      "Django": [".py", "requirements.txt", "settings.py", "urls.py", "wsgi.py", "asgi.py", "manage.py"],
      "Flask": [".py", "requirements.txt", "app.py", "config.py", "Procfile"],
      "FastAPI": [".py", "requirements.txt", "main.py", "config.py", "Dockerfile"],
      "Ruby on Rails": [".rb", "Gemfile", "config.ru", "database.yml", "routes.rb"],
      "ASP.NET": [".cs", ".csproj", "appsettings.json", "web.config"],
      "Kotlin": [".kt", ".kts", "build.gradle.kts", "settings.gradle.kts"],
      "Scala": [".scala", ".sbt", "build.sbt"],
      "Elixir": [".ex", ".exs", "mix.exs"],
      "Rust": [".rs", "Cargo.toml", "Cargo.lock"],
      "PHP": [".php", "composer.json", "composer.lock", ".env"],
      "Perl": [".pl", ".pm", "Makefile.PL", "Build.PL"],
      "R": [".r", ".Rproj", "DESCRIPTION", "NAMESPACE"]
    }
  },
  "SQL": {
    "options": [
      "MongoDB", "MySQL", "SQLite"
    ],
    "fileTypes": {
      "MongoDB": [".json", ".bson", "mongod.conf", ".js", "mongodb.conf"],
      "MySQL": [".sql", ".cnf", "my.cnf", ".frm", ".ibd", "my.ini"],
      "SQLite": [".db", ".sqlite", ".sql", ".sqlite3"],
    }
  },
  "React": {
    "options": [
      "Vue.js", "Angular", "Svelte", "Next.js", "Gatsby", "Nuxt.js", "Ember.js", "Preact", 
      "React Native", "Backbone.js", "Mithril", "Alpine.js", "LitElement", "Stencil.js", "Hyperapp", "Marko"
    ],
    "fileTypes": {
      "Vue.js": [".vue", ".js", "package.json", "vue.config.js", ".env"],
      "Angular": [".ts", ".html", ".scss", "angular.json", "karma.conf.js", ".env"],
      "Svelte": [".svelte", ".js", "rollup.config.js", "svelte.config.js", ".env"],
      "Next.js": [".js", ".jsx", ".ts", ".tsx", "next.config.js", "babel.config.js", ".env.local"],
      "Gatsby": [".js", ".jsx", "gatsby-config.js", "gatsby-node.js", "gatsby-browser.js"],
      "Nuxt.js": [".js", ".vue", "nuxt.config.js", "package.json", "server.js"],
      "Ember.js": [".js", ".hbs", "ember-cli-build.js", "package.json"],
      "Preact": [".js", ".jsx", "preact.config.js", "package.json", ".env"],
      "React Native": [".js", ".jsx", "App.js", "index.js", "metro.config.js"],
      "Backbone.js": [".js", ".html", "backbone.js", "index.html"],
      "Mithril": [".js", "index.html", "mithril.min.js"],
      "Alpine.js": [".html", ".js", "alpine.min.js"],
      "LitElement": [".js", ".html", "lit-element.js", "index.html"],
      "Stencil.js": [".tsx", "stencil.config.ts", "package.json"],
      "Hyperapp": [".js", "index.html", "hyperapp.js"],
      "Marko": [".marko", ".js", "marko.config.json", "index.js"]
    }
  },
  "BTEQ": {
    "options": ["Python", "Java", "C#", "Node.js"],
    "fileTypes": {
      "Python": [".py", "requirements.txt"],
      "Java": [".java", ".class", ".jar"],
      "C#": [".cs", ".csproj"],
      "Node.js": [".js", "package.json"]
    }
  },
  "COBOL": {
    "options": ["Java", "C#", "Python", "Node.js"],
    "fileTypes": {
      "Java": [".java", ".class", ".jar"],
      "C#": [".cs", ".csproj"],
      "Python": [".py", "requirements.txt"],
      "Node.js": [".js", "package.json"]
    }
  },
  "Java": {
    "options": ["Kotlin", "Scala", "Python", "C#", "Node.js"],
    "fileTypes": {
      "Kotlin": [".kt", ".kts"],
      "Scala": [".scala", ".sbt"],
      "Python": [".py", "requirements.txt"],
      "C#": [".cs", ".csproj"],
      "Node.js": [".js", "package.json"]
    }
  },
  "C#": {
    "options": ["Java", "Python", "Node.js", "Go"],
    "fileTypes": {
      "Java": [".java", ".class", ".jar"],
      "Python": [".py", "requirements.txt"],
      "Node.js": [".js", "package.json"],
      "Go": [".go", "go.mod"]
    }
  },
  "C++": {
    "options": ["Rust", "Go", "Java", "Python"],
    "fileTypes": {
      "Rust": [".rs", "Cargo.toml"],
      "Go": [".go", "go.mod"],
      "Java": [".java", ".class", ".jar"],
      "Python": [".py", "requirements.txt"]
    }
  },
  "Rust": {
    "options": ["Go", "C++", "Java", "Python"],
    "fileTypes": {
      "Go": [".go", "go.mod"],
      "C++": [".cpp", ".hpp", ".h"],
      "Java": [".java", ".class", ".jar"],
      "Python": [".py", "requirements.txt"]
    }
  },
  "PySpark": {
    "options": ["Scala", "Java", "Kotlin"],
    "fileTypes": {
      "Scala": [".scala", ".sbt"],
      "Java": [".java", ".class", ".jar"],
      "Kotlin": [".kt", ".kts"]
    }
  },
  "VB": {
    "options": [
      "Vue.js", "Angular", "Svelte", "Next.js", 
      "Gatsby", "Nuxt.js", "Ember.js", "Preact", 
      "React Native", "Backbone.js", "Mithril", "Alpine.js", 
      "LitElement", "Stencil.js", "Hyperapp", "Marko"
    ],
    "fileTypes": {
      "C#": [".cs", ".csproj"],
      "Python": [".py", "requirements.txt"],
      "Java": [".java", ".class", ".jar"],
      "JavaScript": [".js", "package.json"]
    }
  },
  "VB.Net": {
    "options": ["C#", "F#", "Python", "Java"],
    "fileTypes": {
      "C#": [".cs", ".csproj"],
      "F#": [".fs", ".fsproj"],
      "Python": [".py", "requirements.txt"],
      "Java": [".java", ".class", ".jar"]
    }
  },
  "Power Builder": {
    "options": ["Java", "C#", "Python", "JavaScript"],
    "fileTypes": {
      "Java": [".java", ".class", ".jar"],
      "C#": [".cs", ".csproj"],
      "Python": [".py", "requirements.txt"],
      "JavaScript": [".js", "package.json"]
    }
  },
  "Angular": {
    "options": [
      "Vue.js", "React", "Svelte", "Next.js", "Gatsby", "Nuxt.js", "Ember.js", "Preact", 
      "React Native", "Backbone.js", "Mithril", "Alpine.js", "LitElement", "Stencil.js", "Hyperapp", "Marko"
    ],
    "fileTypes": {
      "React": [".jsx", ".tsx", "package.json"],
      "Vue.js": [".vue", "package.json"],
      "Svelte": [".svelte", "package.json"],
      "Ember.js": [".js", ".hbs", "package.json"]
    }
  },
  "MS Access": {
    "options": ["PostgreSQL", "MySQL", "SQLite", "MongoDB"],
    "fileTypes": {
      "PostgreSQL": [".sql"],
      "MySQL": [".sql"],
      "SQLite": [".sqlite", ".db"],
      "MongoDB": [".json"]
    }
  }
};

export const techDetection = [
  { name: "Python", icon: faCode, exts: [".pyc", "requirements.txt", "__init__.py"] },
  { name: "SQL", icon: faDatabase, exts: [".sql", ".ddl", ".dml"] },
  { name: "BTEQ", icon: faCode, exts: [".bteq"] },
  { name: "COBOL", icon: faCode, exts: [".cob", ".cbl", ".cpy"] },
  { name: "Java", icon: faCode, exts: [".java", ".class", ".jar"] },
  { name: "C#", icon: faCode, exts: [".cs", ".csproj"] },
  { name: "C++", icon: faCode, exts: [".cpp", ".hpp", ".h"] },
  { name: "Rust", icon: faCode, exts: [".rs", "Cargo.toml"] },
  //{ name: "PySpark", icon: faCode, exts: [".py"] },
  { name: "VB", icon: faCode, exts: [".vb", ".bas", ".cls", ".frm"] },
  { name: "VB.Net", icon: faCode, exts: [".vb", ".vbproj"] },
  { name: "Power Builder", icon: faCode, exts: [".pbl", ".sra", ".srw"] },
  { name: "MS Access", icon: faDatabase, exts: [".accdb", ".mdb"] },
  { name: "React", icon: faCode, exts: [".jsx", ".tsx"] },
  { name: "Angular", icon: faCode, exts: [".ts", "angular.json"] }
];
